"use client";
import { React, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "./../components/common/BackButton";
import Button from "./../components/common/Button";
import TopBar from "./../components/common/TopBarSignedIn";
import LeftMenuPost from "./../components/postdetail/LeftMenuPost";
import PostContainer from "./../components/postdetail/PostContainer";
import ReplyContainer from "./../components/postdetail/ReplyContainer";

import { useQuery } from "@tanstack/react-query";
import { getPostById, getPostByTopicId } from "../api/postsApi";
import { fetchTopics } from "../api/topicsApi";
import { useUser } from "./../context/UserContext";

function PostDetail() {
  const navigate = useNavigate();

  const { topicId, postId } = useParams();
  const [currentPost, setCurrentPost] = useState(null);
  const { user } = useUser();
  
  // Fetch topics
  const {
    data: post,
    error: errorPost,
    isLoading: isLoadingPost,
  } = useQuery({
    queryKey: ["posts", postId], // Include topicId to refetch when it changes
    queryFn: () => getPostById(postId, user.guid), // ✅ Pass function reference
  });

  // Fetch topics
  const {
    data: dataPost,
    error: errorPosts,
    isLoading: isLoadingPosts,
  } = useQuery({
    queryKey: ["topics", topicId], // Include topicId to refetch when it changes
    queryFn: () => getPostByTopicId(topicId), // ✅ Pass function reference
  });
  
  // Update state when post data changes
  useEffect(() => {
    if (post) {
      setCurrentPost(post);
    }
  }, [post]); // Runs whenever `post` updates

  const handleSelectPost = (postId) => {
    navigate(`/app/topics/${topicId}/posts/${postId}`);
  };

  return (
    <article className="flex overflow-hidden flex-col bg-white text-primary">
      <TopBar />
      <div className="flex flex-1">
        {dataPost && dataPost.posts && (
          <LeftMenuPost
            selectedPostId={postId}
            onSelectPost={handleSelectPost}
            posts={dataPost.posts}
          />
        )}

        <main className="flex-1">
          <div
            className="self-center mt-5 w-full  px-6 overflow-y-scroll"
            style={{ maxHeight: "calc(100vh - 68px)" }}
          >
            <BackButton href={`/app/topics/${topicId}/posts`} />
            {/* <div className="flex flex-wrap gap-4 justify-between items-center w-full max-md:max-w-full">
                            <div className="flex items-center gap-4">
                                <Button
                                    variant="neutral"
                                    icon="arrow-left"
                                    rounded
                                    className="flex gap-2 justify-center items-center self-stretch p-2.5 my-auto border border-gray-700 border-solid min-h-[42px] rounded-[400px] w-[42px]"
                                /> 
                                <span className="text-sm font-medium line-clamp-2 text-gray-700">Topic</span>
                                {
                                    topics && <TopicDropdown
                                        selectedTopic={topicId}
                                        onTopicChange={handleTopicChange}
                                        topics={topics}
                                    />
                                }
                            </div>
                            <SearchInput
                                placeholder="Seek"
                                className="self-stretch my-auto w-80 text-sm leading-loose text-gray-400 whitespace-nowrap min-w-60"
                            />
                        </div>*/}
            {!isLoadingPost && (
              <>
                {currentPost && (
                  <PostContainer
                    postId={currentPost.id}
                    title={currentPost.title}
                    author={currentPost.author}
                    date={currentPost.date}
                    time={currentPost.time}
                    postCount={currentPost.postCount}
                    page={currentPost.page}
                    totalPages={currentPost.totalPages}
                    content={currentPost.content}
                    profileImage={currentPost.profileImage}
                    isOnline={currentPost.isOnline}
                    userPosts={currentPost.userPosts}
                    registrationDate={currentPost.registrationDate}
                    images={currentPost.images}
                    videos={currentPost.videos}
                    initialReadStatus={currentPost.isRead}
                  />
                )}

                {currentPost && (
                  <>
                    <header className="flex flex-wrap gap-4 items-center mt-6 w-full text-gray-700 max-md:max-w-full">
                      <h2 className="flex-1 shrink self-stretch my-auto text-xl font-semibold leading-snug basis-0 max-md:max-w-full">
                        {/* {currentPost.replies.length}{" "}
                                        {currentPost.replies.length === 1 ? "answer" : "answers"} */}
                      </h2>
                      <div className="flex gap-3 items-center self-stretch my-auto text-sm font-medium leading-loose">
                        <span className="self-stretch my-auto text-zinc-600">
                          Sort by:
                        </span>
                        <Button
                          variant="neutral"
                          className="gap-2 self-stretch px-4 py-1.5 my-auto whitespace-nowrap border border-gray-700 border-solid rounded-[400px]"
                        >
                          Date
                        </Button>
                        <Button
                          variant="neutral"
                          className="gap-2 self-stretch px-4 py-1.5 my-auto whitespace-nowrap border border-gray-700 border-solid rounded-[400px]"
                        >
                          reviews
                        </Button>
                      </div>
                    </header>

                    {currentPost.replies &&
                      currentPost.replies.map((reply, index) => (
                        <ReplyContainer
                          key={`${currentPost.id}-reply-${index}`}
                          title={currentPost.title}
                          author={reply.author}
                          date={reply.date}
                          time={reply.time}
                          content={reply.content}
                          isOnline={reply.isOnline}
                          isInactive={reply.isInactive}
                          userPosts={reply.userPosts}
                          registrationDate={reply.registrationDate}
                        />
                      ))}
                  </>
                )}
              </>
            )}
          </div>
        </main>
      </div>
      {/* <Footer /> */}
    </article>
  );
}

export default PostDetail;
